<template>
    <div>
        <default-navigation></default-navigation>
        <section>
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-7">
                        <h1 class="mb-5">404 pagina niet gevonden</h1>
                        <p class="mb-5">De pagina waar je naar op zoek bent kan niet (meer) worden gevonden.</p>

                        <router-link to="/" class="btn btn-primary mb-3">Ga naar de homepage</router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>
